<div id="td-wb-core-system-about-dialog">
  <div>
    <!-- Modal Header -->
    <td-wb-modal-header iconId="overlay--info">
      <td-wb-modal-header-title modalTitle="tdWb.aboutDialog.MESSAGE" />
      <td-wb-modal-header-buttons>
        <td-wb-modal-close-button />
      </td-wb-modal-header-buttons>
    </td-wb-modal-header>
    <div class="td-wb-about-dialog">
      <div>
        <span class="td-wb-about-dialog--label"
              translate="tdWb.aboutDialog.VERSION"></span>
        <span class="td-wb-about-dialog--data"
              [innerText]="aboutData().application.version"></span>
      </div>
      <div class="td-wb-about-dialog--section">
        <span class="td-wb-about-dialog--label"
              translate="tdWb.aboutDialog.REVISION"></span>
        <span class="td-wb-about-dialog--data"
              [innerText]="aboutData().application.revision"></span>
      </div>
      <div class="td-wb-about-dialog--section">
        <span class="td-wb-about-dialog--label"
              translate="tdWb.aboutDialog.PLATFORM"></span>
        <span class="td-wb-about-dialog--data"
              [innerText]="aboutData().browser.platform"></span>
      </div>
      <div class="td-wb-about-dialog--section">
        <div class="td-wb-about-dialog--label"
             translate="tdWb.aboutDialog.USER_AGENT"></div>
        <div class="td-wb-about-dialog--data"
             [innerText]="aboutData().browser.userAgent"></div>
      </div>
      <div class="td-wb-about-dialog--section">
        <div class="td-wb-about-dialog--label"
             translate="tdWb.aboutDialog.BROWSER_VERSION"></div>
        <div class="td-wb-about-dialog--data"
             [innerText]="aboutData().browser.appVersion"></div>
      </div>
      <div class="td-wb-about-dialog--section">
        <div class="td-wb-about-dialog--label"
             translate="tdWb.aboutDialog.LOCATION_ID"></div>
        <div class="td-wb-about-dialog--data"
             [innerText]="aboutData().application.locationId"></div>
      </div>
      <!-- ACTUATOR DATA -->
      @if (actuatorData() | async; as actuator) {
        <div>
          <div class="td-wb-about-dialog--section">
            <div class="td-wb-about-dialog--label"
                 translate="tdWb.aboutDialog.BUILD_TAG"></div>
            <div class="td-wb-about-dialog--data"
                 [innerText]="actuator.buildTag"></div>
          </div>
          <div class="td-wb-about-dialog--section">
            <div class="td-wb-about-dialog--label"
                 translate="tdWb.aboutDialog.BUILD_NUMBER"></div>
            <div class="td-wb-about-dialog--data"
                 [innerText]="actuator.buildNumber"></div>
          </div>
        </div>
      }
    </div>
    <div class="td-wb-about-dialog--buttons">
      <button class="td-wb-about-dialog--button"
              tdWbButton
              tdWbButtonType="primary"
              tdWbModalClose
              translate="tdWb.aboutDialog.CLOSE">
      </button>
    </div>
  </div>
</div>
